//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StripeProvider, Elements } from 'react-stripe-elements';

import makeScriptPromise from '../../lib/makeScriptPromise';
import StripeInjectedCheckoutForm from './CheckoutForm';
import config from '../../config';
import Loading from '../Loading';

type Props = {
  invoiceId: string,
  amount: number,
  promocode?: ?string,
  onSuccess: Function,
  userId: string | null,
  userName: string | null,
  userEmail: string | null,
  userPhoneNumber: string | null,
};

type State = {
  stripe: Object | null,
  stripeError: null | string,
  loading: boolean,
};

const mapStateToProps = ({ user: { email, userId, name } }, ownProps) => ({
  userId,
  userName: ownProps.userName || name || '',
  userEmail: ownProps.userEmail || email || '',
  userPhoneNumber: ownProps.userPhoneNumber || '',
});

class StripePayment extends Component<Props, State> {
  state = { stripe: null, stripeError: null, loading: true };

  componentDidMount() {
    this.initStripe();
  }

  initStripe = async () => {
    try {
      const stripeScriptUrl = 'https://js.stripe.com/v3/';
      await makeScriptPromise(stripeScriptUrl);

      this.setState(() => ({
        stripe: window.Stripe(config.stripe),
        loading: false,
      }));
    } catch (err) {
      this.setState({ stripeError: err.message, loading: false });
    }
  };

  render() {
    const { stripe, stripeError, loading } = this.state;

    if (loading) return <Loading />;
    if (stripeError) return `${stripeError}. Please! refresh the page`;

    return (
      <StripeProvider stripe={stripe}>
        <Elements>
          <StripeInjectedCheckoutForm {...this.props} />
        </Elements>
      </StripeProvider>
    );
  }
}

export default connect(mapStateToProps)(StripePayment);



// WEBPACK FOOTER //
// ./src/components/Stripe/Stripe.js